
define(
	'C3.ShoppingExtensions.LoginRegister'
,   [
		'C3.ShoppingExtensions.LoginRegister.View'
	]
,   function (
		LoginRegisterView
	)
{
	'use strict';

	return  {
		mountToApp: function mountToApp (container)
		{
			// using the 'Layout' component we add a new child view inside the 'Header' existing view 
			// (there will be a DOM element with the HTML attribute data-view="Header.Logo")
			// more documentation of the Extensibility API in
			// https://system.netsuite.com/help/helpcenter/en_US/APIs/SuiteCommerce/Extensibility/Frontend/index.html
			
			/** @type {LayoutComponent} */
			var environment = container.getComponent("Environment");
			var layout = container.getComponent('Layout');
			
			if(layout)
			{
				layout.addToViewEventsDefinition(
						'Header.Profile.View',
						'click [data-action="show-login-register-popup"]',
						function (e) {
							e.stopPropagation();
							e.preventDefault();
							
							var view = new LoginRegisterView({
								application: environment.application
							});

							if (view)
								layout.showContent(view, {showInModal: true});
						}
					);
			}

		}
	};
});
